/**
 * Free VPN for Chrome - VPN Proxy VeePN
 *
 * Most of its exposed assets are Vite build output with content-hashed names
 * (`x-close-BEniuv0u.svg`), which change on every release. The bundled font is the
 * one broadly-exposed asset with a stable filename, so that's the primary probe.
 *
 * Manifest verified against version 4.0.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'majdfhpaihoncoakbjgbdhglocklcgno';

export const veepn: ExtensionDefinition = {
  id: ID,
  name: 'Free VPN for Chrome - VPN Proxy VeePN',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 14_000_000,
  notes:
    'Exposed assets are mostly content-hashed build output; the font is the stable target.',
  signals: [
    {
      id: 'war-figtree-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch fonts/FigtreeVF.woff2 — the bundled variable font, exposed to <all_urls> ' +
        'under a stable filename (unlike the hashed asset bundles beside it).',
      weight: 1,
      run: () => probeFetch(ID, 'fonts/FigtreeVF.woff2'),
    },
  ],
};
